import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';
import { ENPOINT } from '../endpoint';

import { Options } from 'selenium-webdriver/safari';
import { GLOBAL } from '../global';

@Injectable()
export class AccountStatusService {

  constructor(
    private http: HttpClient,
  ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;


  obtenerFacturas(proveedor,folioi, foliof, serie, sociedad, pedido, doc_contable, fechaInicio, fechaFin): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('proveedor', proveedor)
      .set('folioi', folioi)
      .set('foliof', foliof)
      .set('serie', serie)
      .set('sociedad', sociedad)
      .set('pedido', pedido)
      .set('doc_contable', doc_contable)
      .set('fechai', fechaInicio)
      .set('fechaf', fechaFin)
    };
    return this.http.get(this.basePath + 'estado-cta', options); 
 //  return this.http.get('http://proveedoresqas.ddns.net:8081/SistemaContabilidad/estado-cta-prov/obtener-est-cuenta?_dc=1528114654296&proveedor=0000000369&sociedad=1001&fechai=2018-01-01T00%3A00%3A00&fechaf=2018-06-04T00%3A00%3A00&page=1&start=0&limit=25');
  }

  downloadExcelReport(params): Observable<any> {
    return this.http.get(`${this.basePath}estado-cta/excel${params}`, { 
      responseType: 'blob' 
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/account-status/account-status.service.ts